export default "__VITE_ASSET__1960a2df__"